import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Logo } from "./Logo";
import { useAuth } from "../lib/auth";
import ChatbotWidget from "./ChatbotWidget";
import {
  House,
  AirplaneTilt,
  Car,
  Drone,
  Leaf,
  Compass,
  Trophy,
  UserCircle,
  SignOut,
  Plus,
  Robot,
  MagnifyingGlass,
  List as ListIcon,
  X,
  Broadcast,
  Coins,
  Lightning,
  Package,
  Rocket,
  Scales,
  Cpu,
  CaretDown,
  CaretRight,
  Buildings,
  Newspaper,
  Television,
  GraduationCap,
  Microphone,
  ArrowSquareOut,
} from "@phosphor-icons/react";
import { SISTER_PLATFORMS } from "../lib/sisterPlatforms";
import Footer from "./Footer";
import NetworkMenu from "./NetworkMenu";
import { HUB_META } from "../lib/api";

const HUB_NAV = [
  { key: "aerospace", name: "Aerospace", icon: AirplaneTilt },
  { key: "automotive", name: "Automotive", icon: Car },
  { key: "ev", name: "EV & Energy", icon: Lightning },
  { key: "uam", name: "Urban Air Mobility", icon: Drone },
  { key: "logistics", name: "Logistics", icon: Package },
  { key: "stories", name: "Public Transit", icon: Compass },
  { key: "space", name: "Space Access", icon: Rocket },
  { key: "policy", name: "Policy", icon: Scales },
  { key: "sustainability", name: "Sustainability", icon: Leaf },
  { key: "ai", name: "AI & Autonomy", icon: Cpu },
];

function SidebarContent({ onItemClick }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 border-l-2 transition-colors ${
      isActive
        ? "border-[#E60012] bg-[#1A1A1D] text-white"
        : "border-transparent text-zinc-400 hover:text-white hover:bg-[#121214]"
    }`;

  return (
    <div className="flex flex-col h-full">
      <div className="p-5 border-b border-[#27272A]">
        <Link to="/feed" onClick={onItemClick} data-testid="sidebar-logo-link">
          <Logo size={28} />
        </Link>
      </div>

      <nav className="py-3">
        <NavLink to="/feed" end className={linkClass} onClick={onItemClick} data-testid="nav-home">
          <House size={18} weight="regular" />
          <span className="text-sm">All hubs</span>
        </NavLink>
        <NavLink to="/agents" className={linkClass} onClick={onItemClick} data-testid="nav-agents">
          <Robot size={18} weight="regular" />
          <span className="text-sm">AI Agents</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border border-[#E60012]" style={{ color: "#E60012", fontSize: 8 }}>NEW</span>
        </NavLink>
        <NavLink to="/live" className={linkClass} onClick={onItemClick} data-testid="nav-live">
          <Broadcast size={18} weight="regular" />
          <span className="text-sm">Live sessions</span>
        </NavLink>
        <NavLink to="/economy" className={linkClass} onClick={onItemClick} data-testid="nav-economy">
          <Coins size={18} weight="regular" />
          <span className="text-sm">Economy</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border border-[#FFAB00]" style={{ color: "#FFAB00", fontSize: 8 }}>BETA</span>
        </NavLink>
        <NavLink to="/orgs" className={linkClass} onClick={onItemClick} data-testid="nav-orgs">
          <Buildings size={18} weight="regular" />
          <span className="text-sm">Organizations</span>
        </NavLink>
        <NavLink to="/news" className={linkClass} onClick={onItemClick} data-testid="nav-news">
          <Newspaper size={18} weight="regular" />
          <span className="text-sm">News</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border" style={{ color: "#E60012", borderColor: "#E60012", fontSize: 8 }}>DAILY</span>
        </NavLink>
        <NavLink to="/live-tv" className={linkClass} onClick={onItemClick} data-testid="nav-live-tv">
          <Television size={18} weight="regular" />
          <span className="text-sm">Live TV</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border" style={{ color: "#00E676", borderColor: "#00E676", fontSize: 8 }}>24/7</span>
        </NavLink>
        <NavLink to="/courses" className={linkClass} onClick={onItemClick} data-testid="nav-courses">
          <GraduationCap size={18} weight="regular" />
          <span className="text-sm">Courses</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border" style={{ color: "#FFAB00", borderColor: "#FFAB00", fontSize: 8 }}>NEW</span>
        </NavLink>
        <NavLink to="/podcasts" className={linkClass} onClick={onItemClick} data-testid="nav-podcasts">
          <Microphone size={18} weight="regular" />
          <span className="text-sm">Podcasts</span>
          <span className="ml-auto label-mono px-1.5 py-0.5 border" style={{ color: "#E60012", borderColor: "#E60012", fontSize: 8 }}>NEW</span>
        </NavLink>
        <NavLink to="/search" className={linkClass} onClick={onItemClick} data-testid="nav-search">
          <MagnifyingGlass size={18} weight="regular" />
          <span className="text-sm">Search</span>
        </NavLink>
        <NavLink to="/leaderboard" className={linkClass} onClick={onItemClick} data-testid="nav-leaderboard">
          <Trophy size={18} weight="regular" />
          <span className="text-sm">Leaderboard</span>
        </NavLink>
        {user && user.id && (
          <NavLink to={`/profile/${user.id}`} className={linkClass} onClick={onItemClick} data-testid="nav-profile">
            <UserCircle size={18} weight="regular" />
            <span className="text-sm">Profile</span>
          </NavLink>
        )}
      </nav>

      <div className="px-5 py-3 border-t border-[#27272A]">
        <div className="label-mono mb-3">Hubs</div>
        <div className="-mx-5">
          {HUB_NAV.map((h) => (
            <NavLink
              key={h.key}
              to={`/hub/${h.key}`}
              className={linkClass}
              onClick={onItemClick}
              data-testid={`nav-hub-${h.key}`}
            >
              <h.icon size={16} weight="regular" style={{ color: HUB_META[h.key]?.color }} />
              <span className="text-sm">{h.name}</span>
            </NavLink>
          ))}
        </div>
      </div>

      <div className="mt-auto p-5 border-t border-[#27272A]">
        {user && user.id ? (
          <div>
            <div className="flex items-center gap-3 mb-3">
              {user.avatar_url ? (
                <img src={user.avatar_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${user.avatar_url}` : user.avatar_url}
                  alt="" className="w-8 h-8 rounded-full object-cover border border-[#27272A]" data-testid="sidebar-user-avatar" />
              ) : (
                <div
                  className="w-8 h-8 bg-[#E60012] flex items-center justify-center text-white font-display font-black text-sm rounded-full"
                  data-testid="sidebar-user-avatar"
                >
                  {user.name?.[0]?.toUpperCase()}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="text-sm truncate text-white" data-testid="sidebar-user-name">{user.name}</div>
                <div className="label-mono" style={{ fontSize: 9 }}>
                  LVL {user.level} · {user.points} XP
                </div>
              </div>
            </div>
            <button
              onClick={async () => { await logout(); nav("/"); onItemClick?.(); }}
              className="btn btn-ghost btn-sm w-full"
              data-testid="sidebar-logout-btn"
            >
              <SignOut size={14} /> Sign out
            </button>
          </div>
        ) : (
          <Link to="/login" onClick={onItemClick} className="btn btn-primary btn-sm w-full" data-testid="sidebar-login-btn">
            Sign in
          </Link>
        )}
        <div className="mt-4 pt-3 border-t border-[#27272A]" data-testid="sidebar-network-block">
          <div className="label-mono mb-2" style={{ fontSize: 9 }}>IAAM NETWORK</div>
          <div className="space-y-1">
            {SISTER_PLATFORMS.map((p) => (
              <a
                key={p.key}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onItemClick}
                className="flex items-center gap-2 text-xs text-zinc-400 hover:text-white py-1 group"
                data-testid={`sidebar-network-${p.key}`}
              >
                <span className="hub-dot" style={{ color: p.accent }} />
                <span className="flex-1 truncate">{p.name}</span>
                <ArrowSquareOut size={9} weight="bold" className="opacity-60 group-hover:opacity-100" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AppShell({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchQ, setSearchQ] = useState("");

  const submitSearch = (e) => {
    e.preventDefault();
    if (!searchQ.trim()) return;
    nav(`/search?q=${encodeURIComponent(searchQ.trim())}`);
    setSearchQ("");
  };

  return (
    <div className="min-h-screen flex bg-[#0A0A0C]" data-testid="app-shell">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r border-[#27272A] sticky top-0 h-screen">
        <SidebarContent />
      </aside>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden" data-testid="mobile-drawer">
          <div className="absolute inset-0 bg-black/70" onClick={() => setMobileOpen(false)} />
          <aside className="absolute left-0 top-0 bottom-0 w-72 bg-[#0A0A0C] border-r border-[#27272A] overflow-y-auto">
            <div className="flex justify-end p-2">
              <button onClick={() => setMobileOpen(false)} className="btn btn-ghost btn-sm" data-testid="mobile-drawer-close">
                <X size={16} />
              </button>
            </div>
            <SidebarContent onItemClick={() => setMobileOpen(false)} />
          </aside>
        </div>
      )}

      {/* Main */}
      <div className="flex-1 min-w-0">
        <div className="sticky top-0 z-30 bg-[#0A0A0C] border-b border-[#27272A]">
          <div className="flex items-center gap-3 px-4 md:px-8 h-14">
            <button
              onClick={() => setMobileOpen(true)}
              className="md:hidden btn btn-ghost btn-sm"
              data-testid="mobile-menu-btn"
              aria-label="Menu"
            >
              <ListIcon size={18} weight="bold" />
            </button>

            <div className="md:hidden">
              <Logo size={22} withText={false} />
            </div>

            <form onSubmit={submitSearch} className="hidden md:flex items-center flex-1 max-w-md" data-testid="topbar-search-form">
              <div className="relative flex-1">
                <MagnifyingGlass size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-500" />
                <input
                  value={searchQ}
                  onChange={(e) => setSearchQ(e.target.value)}
                  placeholder="Search posts, transcripts, agents..."
                  className="input pl-8 py-1.5 text-sm"
                  data-testid="topbar-search-input"
                />
              </div>
            </form>

            <div className="flex items-center gap-2 ml-auto">
              <div className="hidden md:block">
                <NetworkMenu />
              </div>
              {user && user.id ? (
                <button
                  onClick={() => nav("/compose")}
                  className="btn btn-primary btn-sm"
                  data-testid="topbar-new-post-btn"
                >
                  <Plus size={14} weight="bold" /> <span className="hidden sm:inline">New post</span>
                </button>
              ) : (
                <Link to="/login" className="btn btn-sm" data-testid="topbar-signin-btn">
                  Sign in
                </Link>
              )}
            </div>
          </div>
        </div>

        <main className="px-4 md:px-8 py-8 max-w-7xl mx-auto">{children}</main>

        <Footer />
      </div>
      <ChatbotWidget />
    </div>
  );
}
